import React from "react";
import { Stack } from "@chakra-ui/react";
import GoogleButton from "./Buttons/GoogleButton";
import { IOSGoogleLogin } from "./IOSGoogleLogin";
import { IOSAppleLogin } from "./IOSAppleLogin";

interface SocialAuthButtonsProps {
  authProviders: any[]; // bad
  redirectUrl: string;
  isApplePlatform: boolean;
  userID: number;
  isTemp: boolean;
}

export const SocialAuthButtons: React.FC<SocialAuthButtonsProps> = ({
  authProviders,
  redirectUrl,
  isApplePlatform,
  userID,
  isTemp,
}) => {
  const handleSocialClick = (provider: any) => {
    localStorage.setItem("provider", JSON.stringify(provider));
    localStorage.setItem("isTemp", JSON.stringify(isTemp));
    localStorage.setItem("parrotUserId", JSON.stringify(userID));
  };

  return (
    <Stack spacing={4} width={"100%"}>
      {authProviders.map((provider) => {
        if (provider.name === "apple") {
          if (isApplePlatform) {
            return (
              <IOSAppleLogin
                isTemp={isTemp}
                key={provider.name}
                provider={provider}
                userID={userID}
              />
            );
          }
          return (
            <div key={provider.name}>
              {/* <AppleButton
                className="w-full"
              key={provider.name}
              href={`${provider.authUrl}${redirectUrl}`}
              onClick={() => handleSocialClick(provider)}
            /> */}
            </div>
          );
        }

        if (isApplePlatform) {
          return (
            <IOSGoogleLogin
              key={provider.name}
              provider={provider}
              isTemp={isTemp}
              userID={userID}
            />
          );
        }

        return (
          <GoogleButton
            className="w-full"
            key={provider.name}
            href={`${provider.authUrl}${redirectUrl}`}
            onClick={() => handleSocialClick(provider)}
          />
        );
      })}
    </Stack>
  );
};
